module.exports = __webpack_public_path__ + "img/e1ce1bf.png";